var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import { Pressable, View } from 'react-native';
import { DropdownWidgetComponent as DropdownWidget } from '../../components/dropdown-widget/DropdownWidget';
export var withDropdown = Component => {
  var Wrapper = props => {
    var dropdownRef = useRef({});
    var _props$withDropdown = props.withDropdown,
      withDropdown = _props$withDropdown === void 0 ? false : _props$withDropdown,
      withDropdownProps = props.withDropdownProps,
      restProps = __rest(props, ["withDropdown", "withDropdownProps"]);
    return _jsx(_Fragment, {
      children: withDropdown ? _jsx(DropdownWidget, Object.assign({
        ref: dropdownRef
      }, withDropdownProps, restProps, {
        children: _jsx(Pressable, Object.assign({
          onPress: () => {
            var _a, _b, _c, _d, _e, _f;
            if ((_b = (_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.isDropdownOpen) === null || _b === void 0 ? void 0 : _b.call(_a)) {
              (_d = (_c = dropdownRef.current) === null || _c === void 0 ? void 0 : _c.closeDropdown) === null || _d === void 0 ? void 0 : _d.call(_c);
            } else {
              (_f = (_e = dropdownRef.current) === null || _e === void 0 ? void 0 : _e.openDropdown) === null || _f === void 0 ? void 0 : _f.call(_e);
            }
          }
        }, {
          children: _jsx(View, Object.assign({
            pointerEvents: "none"
          }, {
            children: _jsx(Component, Object.assign({}, restProps))
          }))
        }))
      })) : _jsx(Component, Object.assign({}, restProps))
    });
  };
  return Wrapper;
};